import React from 'react';
import { Router, Switch, Route } from 'react-router-dom';
import PageError from 'components/shared/PageError';
import history from './browserHistory';
import App from './app';

const Routes = () => (
  <Router history={history}>
    <Switch>
      <Route path="/" component={App} />
      <Route component={PageError} />
    </Switch>
  </Router>
);

export default Routes;
